import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'app_modal_framework-show_app_modal-action_category_impression';

/**
 * Tracks when the an app modal is being shown.
 */
export function trackAppModalFrameworkShowAppModalActionCategoryImpression(
  openModalName: string,
  NEXTJS_APPLICATION2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { openModalName, NEXTJS_APPLICATION2 },
  });
}
